import { LongRunningProcessBase } from './base/long-running-process-base';

export class LongRunningProcess extends LongRunningProcessBase { }